import React, {Component} from 'react';
import { Formik, Form } from 'formik';
import DropzoneComponent from 'react-dropzone-component';
import {
    Message,
    Button
} from 'semantic-ui-react';

const componentConfig = {
    iconFiletypes: ['.jpeg', '.jpg', '.png'],
    showFiletypeIcon: true,
    postUrl: 'no-url'
};
const djsConfig = {
    autoProcessQueue: false,
    maxFiles: 1,
    // uploadMultiple: false,
    addRemoveLinks: true,
    // acceptedFiles: 'image/png,image/jpeg,application/pdf'
    acceptedFiles: 'image/png,image/jpeg,image/jpg,image/heif,image/heic',
    init: function() {
        this.on("addedfile", function (file) { 
            let listType = ['image/jpeg', 'image/jpg', 'image/png','image/heif','image/heic']
            var _this = this;  
            let idx = listType.findIndex(type => type == file.type)
            if (idx == -1){
                _this.removeFile(file);
            } 
        });
    },
}

class FormsUpdateProfilePhoto extends Component {
    state = {
        files: [],
        error: false,
        errorMessage: null,
        success: false
    }
    updateFileTest(file) {
        this.setState({files: [...this.state.files, file]});
    }
    renderFormSubmissionResult() {
        if (this.state.success === true) {
            return (
                <Message positive>
                    <Message.Header>Profile Photo Updated Successfully!</Message.Header>
                </Message>
            );
        }
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue with the change</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }
    }
    render() {
        return (
            <Formik
                initialValues={{}}
                validateOnChange={false}
                validateOnBlur={false}
                validate={(values) => {
                    // Additional Validation (if any)
                    let error = {};
                    if (this.state.files.length === 0) {
                        error.uploadAttachments = 'No Files Uploaded.';
                    }
                    if (this.state.files.length > 1) {
                        error.uploadAttachments = 'Only a maxmum of 1 file can be uploaded';
                    }
                    return error;
                }}
                onSubmit={(values, actions) => {
                    console.log("this.state.files ", this.state.files);
                    this.props.submitNewProfilePhoto({attachment: this.state.files, accessToken: this.props.user.accessToken}, (result, error) => {
                        console.log('done');
                        if (error) {
                            console.log('done-failed');
                            actions.setSubmitting(false);
                            this.setState({error: true, success: false, errorMessage: error.message});
                        }
                        if (result) {
                            console.log('done-success');
                            this.props.getUserProfilePhoto(this.props.user.accessToken);
                            this.setState({error: false, success: true, errorMessage: null});
                        }
                    });
                }}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Form style={{paddingBottom: 20, paddingTop: 20}}>
                        <DropzoneComponent
                            config={componentConfig}
                            eventHandlers={
                                {
                                    addedfile: (file) => {
                                        // console.log(file);
                                        if (file.type.includes('jpeg')||
                                            file.type.includes('jpg')||
                                            file.type.includes('png')||
                                            file.type.includes('heif')||
                                            file.type.includes('heic')){
                                                this.updateFileTest(file);
                                            } else {

                                                this.setState({error:true,errorMessage:'Only image file (jpeg, jpg, png) are allowed.', files:[]})
                                            }
                                    },
                                    removedfile: (file) => {
                                        console.log('remove', file);
                                    }
                                }
                            }
                            djsConfig={djsConfig}
                        />
                        {
                            (errors['uploadAttachments']) &&
                            (
                                <Message negative>
                                    {errors['uploadAttachments']}
                                </Message>
                            )
                        }
                        {
                            this.renderFormSubmissionResult()
                        }
                        <Button
                            loading={isSubmitting}
                            type="submit"
                            primary
                            disabled={isSubmitting}
                            fluid
                            size="big"
                        >
                            Update Profile Photo
                        </Button>
                    </Form>
                )}
            />
        );
    }
}

export default FormsUpdateProfilePhoto;
